import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {
  bsRangeValue: Date[];
  data: Date[];
  bsConfig: Partial<BsDatepickerConfig>;

  @Output('datePickerOnValueChange') datePickerOnValueChange: EventEmitter<any> = new EventEmitter();
  constructor() {
  }

  ngOnInit(): void {
    this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue' });
  }
}
